<div class="page-not-found d-flex">
  <div class="page-not-found__main-content w-100">
      <img [src]="imagePath" alt="Sorry, page not found">
  </div>
</div>
